<div class="status-banner" [ngClass]="bannerType" *ngIf="showBanner">
  <span>
    <mat-icon class="banner-icon">{{ bannerIcon }}</mat-icon>
    <span [innerHTML]="bannerMessage"></span>
  </span>
  <a [routerLink]="['/account']" [queryParams]="{ tab: 'subscription' }" class="banner-link">Check account &rarr;</a>
</div>